import { useCallback } from "react";
import axios from "axios";
import { useAuth } from "@/contexts/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SRS_KEY = "sprakbild_srs";
const LEARNED_KEY = "sprakbild_learned";

function loadJSON(key, fallback) {
  try {
    return JSON.parse(localStorage.getItem(key)) ?? fallback;
  } catch {
    return fallback;
  }
}

function applyRating(rec, rating) {
  let ease = rec?.ease ?? 2.5;
  let interval = rec?.interval ?? 0;
  const now = Date.now();
  let due;
  if (rating === "again") {
    ease = Math.max(1.3, ease - 0.2);
    interval = 0;
    due = now + 10 * 60 * 1000;
  } else if (rating === "good") {
    interval = interval < 1 ? 1 : Math.round(interval * ease);
    due = now + interval * 86400000;
  } else {
    ease += 0.1;
    interval = interval < 1 ? 2 : Math.round(interval * ease * 1.5);
    due = now + interval * 86400000;
  }
  return { ease, interval, due };
}

export const useSRS = () => {
  const { user } = useAuth();

  const getDue = useCallback(async () => {
    if (user) {
      const res = await axios.get(`${API}/progress/due`, { withCredentials: true });
      return res.data;
    }
    const learned = loadJSON(LEARNED_KEY, []);
    const srs = loadJSON(SRS_KEY, {});
    const now = Date.now();
    const dueIds = learned.filter((id) => !srs[id] || srs[id].due <= now);
    if (dueIds.length === 0) return { due_count: 0, words: [] };
    const res = await axios.post(`${API}/words/batch`, { ids: dueIds.slice(0, 30) });
    return { due_count: dueIds.length, words: res.data };
  }, [user]);

  const rate = useCallback(async (wordId, rating) => {
    if (user) {
      await axios.post(`${API}/progress/review`, { word_id: wordId, rating }, { withCredentials: true });
      return;
    }
    const srs = loadJSON(SRS_KEY, {});
    srs[wordId] = applyRating(srs[wordId], rating);
    localStorage.setItem(SRS_KEY, JSON.stringify(srs));
  }, [user]);

  return { getDue, rate };
};
